<template>
    <v-dialog
        :model-value="modelValue"
        max-width="560"
        @update:model-value="$emit('update:modelValue', $event)"
    >
        <v-card rounded="lg" class="corporate-dialog">
            <v-card-title class="corporate-dialog__header">
                <div>
                    <h2 class="corporate-dialog__title">{{ t.previewAs.title }}</h2>
                    <p class="corporate-dialog__subtitle">{{ t.previewAs.subtitle }}</p>
                </div>
            </v-card-title>
            <v-card-text class="corporate-dialog__body">
                <section class="corporate-dialog__section">
                    <p class="corporate-dialog__section-label">{{ t.common.sectionData }}</p>
                    <div class="corporate-dialog__section-body">
                        <v-select
                            v-model="sectorId"
                            :items="sectorOptions"
                            item-title="text"
                            item-value="value"
                            :label="t.previewAs.sector"
                            variant="outlined"
                            density="compact"
                            class="weeduc-admin-v-field"
                            hide-details="auto"
                        />
                        <p class="corporate-dialog__hint">{{ t.previewAs.hint }}</p>
                    </div>
                </section>
            </v-card-text>
            <v-card-actions class="corporate-dialog__actions">
                <v-spacer />
                <v-btn variant="text" class="text-none" @click="close">
                    {{ t.common.cancel }}
                </v-btn>
                <v-btn
                    color="primary"
                    variant="flat"
                    rounded="lg"
                    class="text-none"
                    :disabled="!sectorId"
                    @click="confirm"
                >
                    {{ t.previewAs.confirm }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import { corporateI18n } from '@/i18n/mixins';
import organizationalUnitsApi from '@/utils/corporate/organizationalUnits';
import { UNIT_TYPES } from '@/mocks/corporate/store';

export default {
    name: 'PreviewAsDialog',
    mixins: [corporateI18n],
    props: {
        modelValue: { type: Boolean, default: false },
    },
    emits: ['update:modelValue', 'confirmed'],
    data() {
        return {
            sectorId: null,
            units: [],
        };
    },
    computed: {
        sectorOptions() {
            return this.units
                .filter((u) => u.type === UNIT_TYPES.SECTOR && u.status === 'active')
                .map((u) => ({ text: u.name, value: u.id }));
        },
    },
    watch: {
        modelValue(open) {
            if (open) this.loadUnits();
        },
    },
    methods: {
        ...mapActions(['storePreviewAs']),
        close() {
            this.$emit('update:modelValue', false);
        },
        async loadUnits() {
            try {
                const response = await organizationalUnitsApi.list(this.$store.state.token);
                this.units = response.content || response || [];
            } catch (e) {
                this.units = [];
            }
        },
        confirm() {
            const sector = this.units.find((u) => u.id === this.sectorId);
            this.storePreviewAs({
                previewAs: {
                    enabled: true,
                    sectorId: this.sectorId,
                    roleId: null,
                    sectorName: sector?.name || null,
                    roleName: null,
                },
            });
            this.$emit('confirmed');
            this.close();
            this.$router.push('/aluno/dashboard');
        },
    },
};
</script>

<style scoped>
@import '@/css/weeduc/admin/corporate.css';
</style>
